import React, { Fragment, useEffect, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react';
import { formBtn1 } from '../Utils/CustomClasses';
import { useForm } from 'react-hook-form';
import { GetAllRolesAPI } from '../../API/Api';

export default function ViewRoleModal({ RoleModal, setRoleModal,row }) {    
    const { register, handleSubmit, control, watch, reset, formState: { errors }, setValue } = useForm();    
    const toggle = () => {
        setRoleModal(false);
        reset();
    }    
    return (
        <>
            <Transition appear show={RoleModal} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >
                                        Roles Details
                                    </Dialog.Title>
                                    <div className="p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">                                            
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Hierarchy Level</p>
                                                <p>{row?.hierarchyLevel || 'NA'}</p>
                                            </div>
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Role Name</p>
                                                <p>{row?.roleName}</p>
                                            </div>
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Company Name</p>
                                                <p>{row?.company?.companyName}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                        <button
                                            type="button"
                                            className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                                            onClick={toggle}
                                        >
                                            Close
                                        </button>
                                    </footer>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
